import React, { Component } from 'react'
import backArrow from '../../images/paginationBackArrow.svg'
import forwardArrow from '../../images/forwardArrow.svg'

export default class TablePagination extends Component {

  state = {
    pageNum: 1
  }

  onNextClick = () => {
    this.props.onNextClick();
  }

  onPrevClick = () => {
    if (this.props.pageNum === 1) return;
    this.props.onPrevClick();
  }

  disableNext() {
    const { dataLength, pageNum, paginationLimit } = this.props;
    if (dataLength === 0) return true;
    if (paginationLimit !== 0) {
      if (pageNum <= dataLength / paginationLimit) return false;
      if (pageNum > dataLength / paginationLimit) return true;
      if (dataLength % paginationLimit !== 0) return true;
    }
  }


  renderPageNumbers = () => {
    const { dataLength, paginationLimit } = this.props;
    let startPage, endPage;
    let currentPage = this.props.pageNum || 1;
    let totalPages = paginationLimit !== 0 && Math.ceil(dataLength / paginationLimit);

    if (totalPages <= 9) { //if number of pages are less than or equal to 9, display all of them
      startPage = 1;
      endPage = totalPages;
    } else { // if number of pages are more than 9
      if (currentPage <= 8) { //if the user is in first 8 pages, keep displaying all the pages from 1-9
        startPage = 1;
        endPage = 9;
      }
      else { //if user goes to 9th page or pages more than 9, display 5 pages prior the current page and 5 pages ahead the current page
        startPage = currentPage - 5;
        endPage = (currentPage + 5) < totalPages ? (currentPage + 5) : totalPages;
      }
    }
    let pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i)
    }
    const result = (pages.map((item, index) => {
      return (
        <div key={index} className={(this.props.pageNum === item) ? 'currentPageNumber' : 'pageNumber'} onClick={() => this.props.onPageNumClick(item)}>{item}</div>
      )
    }))
    return result;
  }

  render() {
    const { pageNum, isInventoryView, dealPagination=false } = this.props;
    let isDisablePrev = pageNum === 1;
    let isDisableNext = this.disableNext();

    return (
      isInventoryView ?
        // if the view of pagination is as per the new i.e, the one which is in inventory-calendar day-level screen, this ui can be used.
        // extra function called as "onPageNumClick" must be included in the respective component and should be sent as props to this component.
        <div>
          <div className="calendar-pagination">
            {pageNum > 1 && <button
              disabled={isDisablePrev}
              className={`${dealPagination ? 'calendar-pagination-button-dealChages' : 'calendar-pagination-button'} ${!isDisablePrev ? 'app-button' : 'disable-button'}`}
              onClick={this.onPrevClick}
            >
              <img className="backIcon" src={backArrow} alt="icon" />
              <span>Prev</span>
            </button>}
            <div className='pages'>{this.renderPageNumbers()}</div>
            {!isDisableNext && <button
              disabled={isDisableNext}
              className={`${dealPagination ? 'calendar-pagination-button-dealChages' : 'calendar-pagination-button'} ${!isDisableNext ? 'app-button' : 'disable-button'}`}
              onClick={this.onNextClick}
            >
              <span>Next</span>
              <img className="backIcon" src={forwardArrow} alt="icon" />
            </button>}
          </div>
        </div>
        :
        // if the view of pagination is old i.e, the one which is in audit deals list, this ui can be used.
        <div className="row">
          <div className="col-xs-6 col-xs-offset-6 pagination-content">
            Page No: {this.props.pageNum}
            <button
              disabled={isDisablePrev}
              className={`pagination-button ${!isDisablePrev ? 'app-button' : 'disable-button'}`}
              onClick={this.onPrevClick}
            >
              Prev
            </button>
            <button
              disabled={isDisableNext}
              className={`pagination-button ${!isDisableNext ? 'app-button' : 'disable-button'}`}
              onClick={this.onNextClick}
            >
              Next
            </button>
          </div>
        </div>
    )
  }
}
